<div class="cart-side-panel">
  <div class="cart-side-panel__header">
    <span class="cart-side-panel__title">Cart</span>
    <button ftrIconButton icon="Close" (click)="closePanel.emit()">Close</button>
  </div>
  <hr class="cart-side-panel__separator" />
  <div class="cart-side-panel__groups">
    @for (group of cartGroups(); track group.key) {
      <ftr-request-cart-group [group]="group" displayType="small">
        <ng-template #itemTemplate let-item [ftrTypedContext]="group.items">
          <ftr-date [date]="item.requestedTime.start" [format]="dateFormat.TimeWithSeconds" /> -
          <ftr-date [date]="item.requestedTime.end" [format]="dateFormat.TimeWithSeconds" />
        </ng-template>
      </ftr-request-cart-group>
    }
  </div>
  <hr class="cart-side-panel__separator" />
  <div class="cart-side-panel__buttons">
    <a ftrButton color="secondary" [fullWidth]="true" [routerLink]="cartPath()">Go to cart</a>
    <!-- TODO: Navigate to request page -->
    <a ftrFocusableNoopAnchor ftrButton color="primary" [fullWidth]="true">Request</a>
  </div>
</div>
